import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpEvent,	HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

import { ModalService } from 'src/app/shared/services/modal.service';
import { HttpError } from '../models/http-error.model';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

	constructor(private router: Router, private modalService: ModalService) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		return next.handle(request).pipe(

			retry(1),
			catchError((response: HttpErrorResponse) => {

				let httpError : HttpError = null;

				if (response.error instanceof ErrorEvent) {

					var errorMessage = response.error.message;
					console.error(errorMessage);

				} else {

					switch (response.status) {

						case 0:
							var errorMessage = response.message;
                            console.error(errorMessage);
                            this.router.navigate(['/not-available']);
							break;

						// Bad Request.
						case 400:
							httpError = response.error;
							console.error(httpError.message);
                            this.modalService.showErrorModal(httpError.message);
							break;

						// Unauthorized.
						case 401:
							httpError = response.error;
							console.error(httpError.message);
                            this.modalService.showErrorModal(httpError.message);
							break;

						// Forbidden.
						case 403:
							httpError = response.error;
							console.error(httpError.message);
                            this.modalService.showErrorModal(httpError.message);
							break;

						// Internal Server Error.
						case 500:
							httpError = response.error;
							console.error(httpError.message);
                            this.modalService.showErrorModal(httpError.message);
							break;

						default:
							errorMessage = response.error;
							console.error(errorMessage);
                            this.router.navigate(['/not-available']);
							break;

					}
				}

				return throwError(errorMessage);

			})

		);

	}

}
